(function($) {
  'use strict';

  var pathname = window.location.pathname;
  var url      = window.location.href;
  var origin   = window.location.origin;

  if(url == "https://manifeststudio.com/collections/frontpage") {
    $(location).attr('href', origin);
    
  } else if(url == "https://manifeststudio.com/collections/frontpage/products/manifest-street-black-t-shirt") {
    $(location).attr('href', "https://manifeststudio.com/collections/t-shirts/products/manifest-street-black-t-shirt");
    
  } else if(url == "https://manifeststudio.com/collections/frontpage/products/mfs-league-royal-blue-tank-top") {
    $(location).attr('href', "https://manifeststudio.com/collections/tank-tops/products/mfs-league-royal-blue-tank-top");  
    
  } else if(url == "https://manifeststudio.com/collections/frontpage/products/mfs-league-royal-blue-tank-top") {
    $(location).attr('href', "https://manifeststudio.com/collections/tank-tops/products/mfs-league-royal-blue-tank-top");  
    
  } else if(url == "https://manifeststudio.com/collections/frontpage/products/mfs-studio-black-crew-neck-sweater?variant=32062791974956") {
    $(location).attr('href', "https://manifeststudio.com/collections/sweaters/products/mfs-studio-black-crew-neck-sweater?variant=32062791974956");  
    
  } else if(url == "https://manifeststudio.com/collections/frontpage/products/manifest-street-white-t-shirt") {
    $(location).attr('href', "https://manifeststudio.com/collections/t-shirts/products/manifest-street-white-t-shirt");  
    
  } else if(url == "https://manifeststudio.com/collections/frontpage/products/cantt-stop-baby-blue-white-tank-top") {
    $(location).attr('href', "https://manifeststudio.com/collections/tank-tops/products/cantt-stop-baby-blue-white-tank-top");  
    
  } else if(url == "https://manifeststudio.com/collections/frontpage/products/cantt-stop-white-tank-top") {
    $(location).attr('href', "https://manifeststudio.com/collections/tank-tops/products/cantt-stop-white-tank-top");  
    
  } else if(url == "https://manifeststudio.com/collections/frontpage/products/mfs-studio-logo-snapback-hat-red?variant=32062788468780") {
    $(location).attr('href', "https://manifeststudio.com/collections/hats/products/mfs-studio-logo-snapback-hat-red?variant=32062788468780");  
  }

  if($('.artists-section').length > 0) {
    $('body').addClass('no-mt-s');
    $('.art-row .pf-c').each(function () {
      $(this).find('.sc-TtZnY[data-href]').append('<div class="read-more"><span>READ MORE</span></div>');
      $(this).find('.sc-hAcGzb[data-href]').append('<div class="read-more"><span>READ MORE</span></div>');
    });
  }
  if($('.art-det-section').length > 0) {
    $('body').addClass('det-art-page');
    $('body').addClass('no-mt-s');
    
    $('.form input').attr('required', 'required');
    $('.form input').attr('type', 'tel');
  }

  if($('.site-footer').length > 0) {
    let sep = '<ul class="mini-list"></ul>';
    $('.site-footer .grid__item:nth-child(2) .site-footer__links').append($(sep));
    $('.mini-list').append($('.site-footer .grid__item:nth-child(2) .site-footer__links li:nth-child(4)'));
    $('.mini-list').append($('.site-footer .grid__item:nth-child(2) .site-footer__links li:nth-child(4)'));
  }

 if($('#west-covina-local-amenities-manifest-studio').length > 0) {
   $('#shopify-section-footer .grid__item .social-icons').after('<div class="citations"><ul><li><a href="https://www.dexknows.com/west-covina-ca/bp/manifest-studio-inc-559957176" target="_blank">Dex Knows</a></li><li><a href="https://foursquare.com/v/manifest-studio-inc/5f929f0ac9f11f5fe282d418" target="_blank">Foursquare</a></li><li><a href="https://www.dandb.com/businessdirectory/manifeststudioinc.-westcovina-ca-202427771.html" target="_blank">Dandb</a></li><li><a href="https://www.2findlocal.com/b/13691596/manifest-studio-inc-west-covina-ca" target="_blank">2 Find Local</a></li><li><a href="https://www.123local.com/profile/manifest-studio-inc" target="_blank">123 Local</a></li><li><a href="https://www.8coupons.com/stores/local/manifest-studio-inc-west-covina-91790" target="_blank">8 Coupons</a></li><li><a href="https://www.brownbook.net/business/48981066/manifest-studio-inc" target="_blank">Brown Book</a></li><li><a href="https://us.centralindex.com/company/1433228915978240/manifest-studio-inc/west-covina" target="_blank">Central Index</a></li><li><a href="https://www.chamberofcommerce.com/united-states/california/west-covina/tattoos/2012532079-manifest-studio-inc" target="_blank">Chamber Of Commerce</a></li><li><a href="http://www.citysearch.com/profile/750142486/west_covina_ca/manifest_studio_inc_.html" target="_blank">City Search</a></li><li><a href="https://citysquares.com/b/manifest-studio-inc-24009686" target="_blank">City Squares</a></li></ul></div>');
  }

if($('#shopify-section-164209774063e2ffc9').length > 0) {
  console.log("section is here");
  $('#shopify-section-164209774063e2ffc9 .feature-row__text .featured-row__subtext p').after('<ul><li>Baldwin Park</li><li>Hacienda Heights</li><li>Rowland Heights</li><li>Covina</li><li>Diamond Bar</li><li>Glendora</li><li>La Puente</li><li>Azusa</li><li>Charter Oak</li><li>El Monte</li><li>City Of Industry</li>');
  }

$(document).ready(function() {
console.log("Hello There!")
if (window.location.href.indexOf('?customer_posted=true#contact_form') !== -1) {
  console.log("General Kenobi")
  $('html, body').animate({
    scrollTop: $(document).height()
  }, 1000);
}
});

})(jQuery);